import { useEffect, useState, useRef, useCallback } from "react";
import _debounce from "lodash/debounce";
import isMobile from "ismobilejs";
import { getScrollContainer } from "../../utils/scrollContainer";

export const createHandleScroll = (element, setSticky, top) => () => {
  const isMobileBrowser = isMobile(window.navigator).any;
  if (!element.current) return;
  if (!top) return;

  if (isMobileBrowser) {
    const scrollTop = getScrollContainer()?.scrollTop ?? 0;
    setSticky(scrollTop > top);
  }
};

function useSticky() {
  const [isSticky, setSticky] = useState(false);
  const [top, setTop] = useState();
  const element = useRef(null);

  useEffect(() => {
    if (element.current && element.current.getBoundingClientRect && !top) {
      setTop(element.current.getBoundingClientRect().top);
    }
  }, [top, element]);

  const handleScroll = useCallback(
    createHandleScroll(element, setSticky, top),
    [top]
  );

  useEffect(() => {
    const target = getScrollContainer();
    if (!target) return undefined;
    const debounced = _debounce(handleScroll, 10);
    target.addEventListener("scroll", debounced);
    return () => {
      target.removeEventListener("scroll", debounced);
    };
  }, [handleScroll]);

  return { isSticky, element };
}

export default useSticky;
